import React, { useState } from "react";
import "./App.css";
import "./MainPage.css";

const bannerUrl = "/cor-logo-high-res_no_white.webp";

const LoginPage = () => {
  //const [username, setUsername] = useState("");
  //const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [clicked, setClicked] = useState(false);
  const [hover, setHover] = useState(false);

  const handleClick = () => {
    setClicked(true);
    setTimeout(() => setClicked(false), 0); // Reset after animation
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    window.location.replace("/api/auth/login");
    return;
  };

  return (
    <>
      <div className="top-banner">
        <img src={bannerUrl} alt="Banner" />
      </div>

      <div style={styles.container}>
        <h2>Login to Cortime</h2>
        <form onSubmit={handleSubmit} style={styles.form}>
          {/* <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={styles.input}
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
          /> */}

          {error && <p style={styles.error}>{error}</p>}
          {message && <p style={styles.message}>{message}</p>}

          <button
            className={`animated-button ${clicked ? "clicked" : ""}`}
            onClick={handleClick}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: hover ? "#020202" : "#2f2f2f",
              color: "#fff",
              transition: "background-color 150ms ease",
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginRight: 8 }}
            >
              <rect x="1" y="1" width="9" height="9" fill="#F25022" />
              <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
              <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
              <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
            </svg>
            <div style={{ fontSize: "1.2rem" }}>Sign in with Microsoft</div>
          </button>
        </form>
      </div>
    </>
  );
};

const styles = {
  container: {
    maxWidth: "400px",
    margin: "50px auto",
    padding: "20px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    textAlign: "center",
  },
  form: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  input: {
    margin: "10px 0",
    padding: "10px",
    fontSize: "16px",
  },
  button: {
    padding: "10px",
    fontSize: "16px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    width: "100%",
  },
  error: {
    color: "red",
    fontSize: "14px",
  },
};

export default LoginPage;
